import { Icon } from '@ab-core/icon';
import type { InputProps } from '@ab-core/input';
import { BasicInput } from '@ab-core/input';
import { getTestIdProp } from '@ab-core/testing';
import type { FC } from 'react';
import React, { useState } from 'react';
import type { ScalableStyle } from '../../scalableStyles';
import { InputWrapper, LinkText, StyledPositionTextContainer } from './styled';

export type PositionTextContainerStyleType = ScalableStyle<{
    isVisible: boolean;
}>;

export type PositionTextContainerProps = {
    onPositionTextUpdate?: (positionText: string) => void;
    positionText: string;
};

export const PositionTextContainer: FC<PositionTextContainerProps & PositionTextContainerStyleType> = (props) => {
    const { positionText, onPositionTextUpdate, scalableStyle } = props;
    const [isActive, setIsActive] = useState(false);

    const onInputChange: InputProps['onChange'] = (e) => {
        const value = e.target.value;

        if (!value && value !== '') {
            return;
        }

        if (!onPositionTextUpdate) {
            return;
        }

        onPositionTextUpdate(value);
    };

    const handleOnClick = () => {
        setIsActive(true);
    };

    const onInputFocusOut: InputProps['onBlur'] = (e) => {
        const value = e.target.value;

        if (value === '' || !value) {
            setIsActive(false);
        }
    };

    if (!scalableStyle?.isVisible) {
        return <></>;
    }

    return (
        <StyledPositionTextContainer>
            {!isActive && (
                <LinkText {...getTestIdProp('product-card-position-text')} onClick={handleOnClick}>
                    <Icon name="Edit" size="SMALL_4" />
                    Positiontext hinzufügen
                </LinkText>
            )}
            {isActive && (
                <InputWrapper>
                    <BasicInput
                        {...getTestIdProp('product-card-position-text-input-field')}
                        autoFocus
                        onBlur={onInputFocusOut}
                        onChange={onInputChange}
                        label="Positionstext"
                        maxLength={80}
                        value={positionText}
                        icon={{
                            name: 'Close',
                            action: () => (onPositionTextUpdate ? onPositionTextUpdate('') : undefined)
                        }}
                    />
                </InputWrapper>
            )}
        </StyledPositionTextContainer>
    );
};
